export const patternFeaturedCaseStudies = () => {
  $('.pattern-featured-case-studies .case-studies').first().addClass('is-active');
  $(
    '.pattern-featured-case-studies .case-studies .wp-block-post-title'
  ).hover(function () {
    if (!$(this).closest('.case-studies').hasClass('is-active')) {
      $('.case-studies.is-active').removeClass('is-active');
      $(this).closest('.case-studies').addClass('is-active');
    }
  });
};
